/**
 * Melco EXP. 머리글 없음. 바늘땀 = 부호 있는 1바이트 dx, -dy.
 * 명령: 0x80 0x04 dx dy 점프, 0x80 0x80 0x07 0x00 트림, 0x80 0x01 0x00 0x00 색 바꿈.
 * pyembroidery (MIT) 의 ExpWriter.py 를 옮겼다. NOTICE.md 참고.
 */
import { COLOR, END, JUMP, STITCH, type StitchPlan, TRIM } from "../engine/plan";
import { ByteWriter } from "./bytes";

export function writeExp(plan: StitchPlan): Uint8Array {
  const w = new ByteWriter(plan.cmds.length * 4 + 16);
  let px = 0,
    py = 0;
  for (let i = 0; i < plan.cmds.length; i++) {
    const c = plan.cmds[i];
    const x = plan.xs[i],
      y = plan.ys[i];
    const dx = x - px,
      dy = y - py;
    if (c === STITCH) {
      w.u8(dx & 0xff);
      w.u8(-dy & 0xff);
    } else if (c === JUMP) {
      w.bytes([0x80, 0x04]);
      w.u8(dx & 0xff);
      w.u8(-dy & 0xff);
    } else if (c === TRIM) {
      w.bytes([0x80, 0x80, 0x07, 0x00]);
      continue;
    } else if (c === COLOR) {
      w.bytes([0x80, 0x01, 0x00, 0x00]);
      continue;
    } else if (c === END) break;
    px = x;
    py = y;
  }
  return w.result();
}
